<div class="repair-diagram repair-diagram-dialog">
  <!-- Repair Diagram Title -->
  <div class="repair-diagram-dialog-header flex-between-center">
    <p class="m-0 font-bold">
      <i class="fal fa-file-alt font-16 pr-2"></i>
      <span>{{title}}</span>
    </p>

    <span>
      <span class="open-full-modal mr-3 pl-1 pr-1">
      </span>
      <span class="close-modal">
        <i class="fal fa-times" (click)="handleClose()"></i>
      </span>

    </span>
  </div>

  <!-- Repair Diagram Body -->
  <div class="repair-diagram-dialog-body flex-column flex-start-start">

    <div class="rd-component-diagram repair-diagram-content flex-row">
      <!-- Dialog Left Side Content -->
      <div class="repair-diagram-content-left">
        <!-- List of Component location & Illustration -->
        <div class="repair-diagram-list flex-column">
          <div *ngFor="let image of images; let imageIndex = index"
            class="repair-diagram-list-item flex-start-center pointer"
            [ngClass]="{'active': currentImage?.anchorDocumentId == image?.anchorDocumentId}"
            (click)="handleSelectImage(image)">
            <p class="mb-0 flex-column">
              <span class="font-600">Fig. {{imageIndex + 1}}. {{image?.caption}}</span>
            </p>
          </div>
        </div>
      </div>

      <!-- Dialog Right Side Content -->
      <div class="repair-diagram-content-right repair-diagram-wrapper">
        <angular-image-viewer *ngIf="currentImage?.image" [index]="0" [src]="[currentImage?.image]" [config]="config">
        </angular-image-viewer>
      </div>
    </div>
  </div>
</div>
